import { render, staticRenderFns } from "./SUPACell.vue?vue&type=template&id=2965d8cb&scoped=true&"
import script from "./SUPACell.vue?vue&type=script&lang=ts&"
export * from "./SUPACell.vue?vue&type=script&lang=ts&"
import style0 from "./SUPACell.vue?vue&type=style&index=0&id=2965d8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965d8cb",
  null
  
)

export default component.exports